// Hooks / Node modules / Styles

// Reducers / Actions

// Utils / Functions

// Components
import DefaultLayout from "src/layout/standard/primary/DefaultLayout";
import TitleBar from "src/components/base/title-bar/TitleBar";

// Sub-Components
import CertificationCardGroup from "./com/CertificationCardGroup";

// Data / Images / Icons

function P_Certifications() {
  return (
    <DefaultLayout>
        <TitleBar />

        <CertificationCardGroup/>
    </DefaultLayout>
  )
}

export default P_Certifications